export const INTERNAL_API_BASE = {
  API: "/api",
  API_V1: "/api/v1",
} as const;

export const INTERNAL_API_ENDPOINTS = {
  CLIENT_LOGS: `${INTERNAL_API_BASE.API}/client-logs`,
  ENVIRONMENT_CONFIG: `${INTERNAL_API_BASE.API}/environment-config`,
  FEATURE_BOOTSTRAP: `${INTERNAL_API_BASE.API_V1}/features/bootstrap`,
  ADDRESS_SEARCH: `${INTERNAL_API_BASE.API_V1}/address-search`,
  FREEZE_APPOINTMENT: `${INTERNAL_API_BASE.API_V1}/freeze-appointment`,
  GET_TIMEZONE: `${INTERNAL_API_BASE.API_V1}/get-timezone`,
  INSURANCE_PACKAGE: `${INTERNAL_API_BASE.API_V1}/insurancepackage`,
  PARTNERS: `${INTERNAL_API_BASE.API_V1}/partners`,
  PATIENT_DATA: `${INTERNAL_API_BASE.API_V1}/patient-data`,
  PATIENT_SEARCH: `${INTERNAL_API_BASE.API_V1}/patient-search`,
  PORTAL_REGISTRATION_START: `${INTERNAL_API_BASE.API_V1}/portal-registration/start`,
  PORTAL_REGISTRATION_INVITATION: `${INTERNAL_API_BASE.API_V1}/portal-registration/invitation`,
  PROVIDER_DATES: `${INTERNAL_API_BASE.API_V1}/provider-dates`,
  PROVIDER_PHOTOS: `${INTERNAL_API_BASE.API_V1}/provider-photos`,
  PROVIDER_SEARCH: `${INTERNAL_API_BASE.API_V1}/provider-search`,
  LOCAL_CENTER_PROVIDER_SEARCH: `${INTERNAL_API_BASE.API_V1}/provider-search/local-center`,
  PROVIDER_AVAILABILITY_BATCH: `${INTERNAL_API_BASE.API_V1}/provider-availability-batch`,
  PROVIDER_SLOTS: `${INTERNAL_API_BASE.API_V1}/provider-slots`,
  POLLING_STATUS: `${INTERNAL_API_BASE.API_V1}/polling-status`,
  REASONS_FOR_VISIT: `${INTERNAL_API_BASE.API_V1}/reasons-for-visit`,
  REFERRER_TEAMS: `${INTERNAL_API_BASE.API_V1}/referrer-teams`,
  REFERRERS: `${INTERNAL_API_BASE.API_V1}/referrers`,
  SCHEDULE_APPOINTMENT: `${INTERNAL_API_BASE.API_V1}/schedule-appointment`,
  SCREENER_ANSWERS: `${INTERNAL_API_BASE.API_V1}/screener-answers`,
  UNFREEZE_APPOINTMENTS: `${INTERNAL_API_BASE.API_V1}/unfreeze-appointments`,
  USER_DIGITAL_INFO: `${INTERNAL_API_BASE.API_V1}/user-digital-info`,
  USER_LEAD: `${INTERNAL_API_BASE.API_V1}/user-lead`,
} as const;
